module.exports = __webpack_public_path__ + "img/中国移动.860560bb.png";